import VideoLoader from "e.sic-platform.webclient/src/pages/analysis/components/VideoLoader";
import VideoPlayer from 'e.sic-platform.webclient/src/components/video-player/VideoPlayer';
import { VideoAnalysisService } from "e.sic-platform.webclient/src/services/inspection/VideoAnalysisService";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { videoPlayerService } from 'e.sic-platform.webclient/src/services/video-player/VideoPlayerService';

export default observer(function VideoAnalysisPlayer(props:{videoAnalysis:VideoAnalysisService}) {
    const {videoAnalysis} = props;

    useEffect(() => {
        videoPlayerService.loadVideoTimestamps(undefined);
        videoPlayerService.loadVideo(videoAnalysis.video!.videoUrl);
    }, [videoAnalysis.video, videoPlayerService.loadVideoTimestamps, videoPlayerService.loadVideo])

    return (
        <>
            <VideoLoader 
                canConvert={true}
                reloadFunction={videoAnalysis.reload}
                video={videoAnalysis?.video}
            />
            {videoAnalysis?.video!.isAvailable && <VideoPlayer videoAnalysis={videoAnalysis}/>}
        </>
    )
})